import { listSentence } from '@/lib/formatters'

export const MAX_INTAKE_FILES = 10
export const MAX_INTAKE_FILE_MB = 25
export const MAX_INTAKE_TOTAL_MB = 50

const MB = 1024 * 1024

/** Why these files can't go up as one drop, or null. The server checks the same limits again. */
export function intakeFilesProblem(files: File[]): string | null {
  if (files.length > MAX_INTAKE_FILES) {
    return `Drop up to ${MAX_INTAKE_FILES} files at a time. You dropped ${files.length}.`
  }
  const tooBig = files.filter((file) => file.size > MAX_INTAKE_FILE_MB * MB).map((file) => file.name)
  if (tooBig.length > 0) {
    return `${listSentence(tooBig)} ${tooBig.length === 1 ? 'is' : 'are'} over ${MAX_INTAKE_FILE_MB} MB.`
  }
  const total = files.reduce((sum, file) => sum + file.size, 0)
  if (total > MAX_INTAKE_TOTAL_MB * MB) {
    return `These files add up to more than ${MAX_INTAKE_TOTAL_MB} MB. Drop fewer at a time.`
  }
  return null
}
